export default [
  {
    text: 'Timed at',
    value: 'release_date',
    width: '195px',
    sortable: false,
  },
  {
    text: 'Deal',
    value: 'deal',
    width: '70%',
    sortable: false,
  },
  {
    text: 'Merchant',
    value: 'merchant',
    width: '20%',
    sortable: false,
  },

];
